import { render, staticRenderFns } from "./CalendarTaskDetailDialog.vue?vue&type=template&id=86bc29a0"
import script from "./CalendarTaskDetailDialog.vue?vue&type=script&lang=js"
export * from "./CalendarTaskDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports